import React from "react";

import BaseChart from "./BaseChart";
import { COLORS } from "Constants";
import { calcXRangeAxisMaxAndMin, mapXRangeChartSeries } from "utilities/chart";
import { ChartFieldsFragment } from "generated/graphql";

interface XRangeChartProps {
  categories: Array<string>;
  colors: Array<string>;
  height?: number;
  legendItemClickable?: boolean;
  series?: ChartFieldsFragment["series"];
  title?: string;
  xMax?: number;
  xMin?: number;
  yLabel?: string;
}

export const XRangeChart: React.FC<XRangeChartProps> = props => {
  let {
    categories = [],
    colors = [],
    height,
    legendItemClickable = false,
    series,
    title,
    yLabel
  } = props;

  const newSeries = mapXRangeChartSeries(series);
  const { min, max } = calcXRangeAxisMaxAndMin(newSeries);

  return (
    <BaseChart
      colors={colors}
      options={{
        chart: {
          type: "xrange",
          height: height
        },
        title: {
          text: title || "",
          align: "left",
          style: {
            color: COLORS.WHITE
          }
        },
        series: newSeries,
        xAxis: {
          min,
          max,
          endOnTick: true,
          type: "datetime",
          // datetime axes based on milliseconds
          tickInterval: 60 * 60 * 1000,

          dateTimeLabelFormats: {
            millisecond: "%H:%M:%S.%L",
            second: "%H:%M:%S",
            minute: "%H:%M",
            hour: "%H:%M",
            day: "%e. %b",
            week: "%e. %b",
            month: "%b '%y",
            year: "%Y"
          }
        },

        yAxis: {
          title: {
            text: yLabel
          },
          gridLineWidth: 0,
          tickAmount: 0,
          categories,
          reversed: true,
          labels: {
            enabled: true
          }
        },
        legend: {
          itemStyle: {
            color: COLORS.WHITE,
            cursor: "default"
          },
          itemHoverStyle: {
            color: COLORS.WHITE
          }
        }
      }}
      plotOptions={{
        series: {
          events: {
            legendItemClick: function() {
              return legendItemClickable;
            }
          }
        }
      }}
    />
  );
};

export default XRangeChart;
